module.exports = __webpack_public_path__ + "static/img/icon_6.72dbd6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/icon_6.png
// module id = epB6
// module chunks = 49